export const events = {
  LOAD_MORE: 'Load more Triggered',
  RESOURCE_ACCESS: 'Resource Accessed',
  RESOURCE_ADD: 'Resource Added',
  SEARCH_SEARCHED: 'Search Searched',
  USER_SIGNUP: 'User Signed Up',
  USER_SIGNIN: 'User Signed In',
  USER_SIGNOUT: 'User Signed Out',
  PAGE: 'Page Visited',
  TAG_CLICKED: 'Tag Clicked',
  NEWSLETTER_SUBSCRIBED: 'Newsletter Subscribed'
}

const prefixes = {
  TOTAL: 'Total ',
  LAST: 'Last '
}

/** Increment super property */
export function superIncrement (property, value = 1) {
  if (value === undefined) {
    value = 1
  }
  var nowString = new Date().toISOString()
  window.analytics.ready(function () {
    const totalKey = prefixes.TOTAL + property
    const lastKey = prefixes.LAST + property

    // Get current value from Mixpanel
    var totalValue = window.mixpanel.get_property(totalKey)
    if (typeof totalValue === 'undefined') {
      totalValue = value
    } else {
      totalValue += value
    }

    const props = { [totalKey]: totalValue, [lastKey]: nowString }
    window.mixpanel.register(props)

    // People
    const incrementProps = { [totalKey]: value }
    const lastProps = { [lastKey]: nowString }

    window.mixpanel.people.increment(incrementProps)
    window.mixpanel.people.set(lastProps)
    window.mixpanel.identify()
  })
}

export function trackAndIncrement (eventName, params) {
  window.analytics.track(eventName, params)
  superIncrement(eventName)
}
